import useCreateMenuItems from "@hooks/useCreateMenuItems"

import { faIcon } from "@utils/faIcon"

import { Menu } from "@organisms"
import NavBottomBarItem from "@organisms/NavBottomBar/NavBottomBarItem/NavBottomBarItem"

import { NavBottomBarCreateObjectProps } from "./NavBottomBarCreateObject.types"

export default function NavBottomBarCreateObject(props: NavBottomBarCreateObjectProps) {
    const { isDisabled = false, _isFocused = false, _isHovered = false, isPressed = false } = props

    const menuContentItems = useCreateMenuItems()

    return (
        <Menu
            title="Create Object"
            trigger={
                <NavBottomBarItem
                    title="Create Object"
                    icon={faIcon({ name: "plus", style: "regular" })}
                    iconActive={faIcon({ name: "plus", style: "solid" })}
                    isDisabled={isDisabled}
                    _isFocused={_isFocused}
                    _isHovered={_isHovered}
                    isPressed={isPressed}
                />
            }
            items={[{ type: "group", items: menuContentItems }]}
        />
    )
}
